import React from 'react';
import './SinglePagePanel.css';
import { Panel, PanelType } from '@fluentui/react';
import SinglePage from '../SinglePage/SinglePage';
import WorkflowEntry from '../WorkflowEntry/WorkflowEntry';
import ViewRecord from '../../Containers/ViewRecord/ViewRecord';
// import RightHelp from '../../General/RightHelp/RightHelp';


const SinglePagePanel = (props) => {

    // const [helpVisible, setHelpVisible] = useState(false);

    // const openHelpView = () => {
    //     setHelpVisible(true);
    // }

    let formtodisplay;

    let type = PanelType.medium;
    let width = undefined;
    if (props.currentPage.ExtraWide) {
        type = PanelType.extraLarge;
    } else if (props.currentPage.Wider) {
        type = PanelType.custom;
        width = '1000px';
    } else if (props.currentPage.Wide) {
        type = PanelType.large;
    }

    if (props.config.Pages.length === 1) {
        let data = props.config.data;
        if (props.config.Pages[0].Crafted) {
            if (props.config.data !== undefined && props.config.data.Crafted !== undefined) {
                data = props.config.data.Crafted[0].Contents;
                if (data.length === 0) {data.id = props.id; }
            }
        }
        formtodisplay = <SinglePage
                            config={props.config.Pages[0]}
                            fullScreen={props.fullScreen}
                            displayModeSwitchable={props.displayModeSwitchable}
                            fullScreenClick={props.fullScreenClick}
                            close={props.close}
                            data={data}
                            id={props.id}
                            currentPage={props.currentPage}
                            save={props.save}
                            error={props.error}
                            changeHandler={props.changeHandler}
                            errorCloseHandler={props.errorCloseHandler}
                            refresh={props.refresh}
                            language={props.language}
                            saveEnabled={props.saveEnabled}
                            fieldFocusOut={props.fieldFocusOut}
                            records={props.records}
                            startConfig={props.startConfig}
                            showNextButton={props.showNextButton}
                        >
                        </SinglePage>
    } else 
    {
        formtodisplay = <WorkflowEntry
                            currentPage={props.currentPage}
                            config={props.config}
                            fullScreen={props.fullScreen}
                            displayModeSwitchable={props.displayModeSwitchable}
                            fullScreenClick={props.fullScreenClick}
                            close={props.close}
                            data={props.config.data}
                            inputData={props.config.inputData}
                            save={props.save}
                            id={props.id}
                            next={props.next}
                            previous={props.previous}
                            error={props.error}
                            changeHandler={props.changeHandler}
                            fieldFocusOut={props.fieldFocusOut}
                            errorCloseHandler={props.errorCloseHandler}
                            refresh={props.refresh}
                            language={props.language}
                            saveEnabled={props.saveEnabled}
                            state={props.state}
                            //showHelp={openHelpView}
                        >
                        </WorkflowEntry>
    }

    // Experimental hot-key.
    document.onkeydown = function(e) {
        if (e.key === "Escape") {
            props.close();
        }
    };

    let display;
    if (props.fullScreen) {
        if (!props.config.SuppressRecordView) {
            display =
                <div className='singlepagepanel-columns'>
                    <div className='singlepagepanel-column-left'>
                        <ViewRecord
                            itemId={props.id}
                            type={props.recordType}
                            reportConfiguration={props.reportConfiguration}
                        >
                        </ViewRecord>
                    </div>
                    <div className='singlepagepanel-column-right'>
                        {formtodisplay}
                    </div>
                </div>
        } else {
            display =
                <div>
                    {formtodisplay}
                </div>
        }
    } else {
        display = <Panel
                    isOpen={props.visible}
                    onDismiss={props.close}
                    type={type}
                    customWidth={width}
                    hasCloseButton={false}
                  >
                    {formtodisplay}
                  </Panel>
    }

    return (
        <div>
            {display}
        </div>

    )
};

export default SinglePagePanel;